// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__nVvrw","footerInner":"style_footerInner__5F3UT","logo":"style_logo__phaUJ"};